module.exports = __webpack_public_path__ + "img/icon-download-slim.8b0bc68f.svg";